//Redux
import { useDispatch, useSelector } from "react-redux";
import { setComponentActive, setOrder } from "../../reducers/userConfigSlice";
import { Button } from "@delibrandev/utils";
import { FiShoppingBag } from "react-icons/fi";
import "./style.css";

export const DeliveryFailed = () => {
  const dispatch = useDispatch();
  const order = useSelector((state) => state.aplicationConfig.userConfig.order);

  const handleNavigation = (component, order = null) => {
    order !== null && dispatch(setOrder(order));
    dispatch(setComponentActive("" + component));
  };

  return (
    <div className="paymentError">
      <div className="paymentresponse">
        <div className="paymentIconError">
          <FiShoppingBag />
        </div>
        <div className="paymentTitle">¡Pedido no entregado!</div>
        <div className="paymentDescription">
          {order.reportDetails
            ? `El pedido ha sido reportado: ${order.reportDetails}`
            : "El pedido ha sido reportado."}
        </div>
      </div>
      <div className="paymentDoneAction">
        <Button
          text={"Volver a pedidos"}
          icon={null}
          customClass={""}
          action={() => handleNavigation("delivery")}
        />
      </div>
    </div>
  );
};